(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["victorious-heritage-home"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    let paused = reduced.matches;
    const update = () => {
      const active = true;
      document.querySelectorAll('[data-vh-home]').forEach(home => {
        home.dataset.motionPaused = String(paused || !active);
        home.querySelectorAll('[data-vh-motion-toggle]').forEach(button => {
          button.textContent = paused ? button.dataset.play : button.dataset.pause;
          button.setAttribute('aria-pressed', String(paused));
        });
        home.querySelectorAll('video').forEach(video => {
          if (paused || !active || video.dataset.inView !== 'true' || document.hidden) {
            video.pause();
            video.dataset.playing = 'false';
          } else {
            video.play().then(() => { video.dataset.playing = 'true'; }).catch(() => { video.dataset.playing = 'false'; });
          }
        });
      });
    };
    const observe = () => {
      document.querySelectorAll('[data-vh-home] video:not([data-vh-observed])').forEach(video => {
        video.dataset.vhObserved = 'true';
        new IntersectionObserver(entries => { video.dataset.inView = String(entries[0].isIntersecting); update(); }, { threshold: .15 }).observe(video);
      });
      update();
    };
    document.addEventListener('click', event => { if (event.target.closest('[data-vh-motion-toggle]')) { paused = !paused; update(); } });
    document.addEventListener('victorious:appearance-change', update);
    document.addEventListener('visibilitychange', update);
    document.addEventListener('shopify:section:load', observe);
    reduced.addEventListener('change', event => { paused = event.matches; update(); });
    observe();
  })();

  (() => {
    const setup = () => document.querySelectorAll('[data-vh-celebration]:not([data-ready])').forEach(root => {
      const slides = [...root.querySelectorAll('[data-vh-slide]')];
      if (slides.length < 2) return;
      root.dataset.ready = 'true';
      const motion = matchMedia('(prefers-reduced-motion: reduce)');
      const controls = root.querySelector('[data-vh-slide-controls]');
      const pause = root.querySelector('[data-vh-slide-pause]');
      const count = root.querySelector('[data-vh-slide-count]');
      let index = 0, paused = motion.matches, visible = false, timer;
      controls.hidden = false;
      const sync = () => { pause.textContent = paused ? 'Play slides' : 'Pause slides'; pause.setAttribute('aria-pressed', String(paused)); clearInterval(timer); if (!paused && visible && !document.hidden) timer = setInterval(() => show(index + 1, false), 7000); };
      const show = (next, manual) => { index = (next + slides.length) % slides.length; slides.forEach((s,i) => s.hidden = i !== index); count.setAttribute('aria-live', manual ? 'polite' : 'off'); count.textContent = (index + 1) + ' / ' + slides.length; if (manual) paused = true; sync(); };
      root.querySelector('[data-vh-slide-prev]').addEventListener('click', () => show(index - 1, true));
      root.querySelector('[data-vh-slide-next]').addEventListener('click', () => show(index + 1, true));
      pause.addEventListener('click', () => { paused = !paused; sync(); });
      root.addEventListener('focusin', e => { if (!e.target.closest('[data-vh-slide-pause]')) { paused = true; sync(); } });
      root.addEventListener('pointerenter', () => { clearInterval(timer); });
      root.addEventListener('pointerleave', sync);
      document.addEventListener('visibilitychange', sync);
      motion.addEventListener('change', () => { paused = motion.matches; sync(); });
      new IntersectionObserver(entries => { visible = entries[0].isIntersecting; sync(); }, {threshold:.15}).observe(root);
      sync();
    });
    setup(); document.addEventListener('shopify:section:load', setup);
  })();


(()=>{const setup=()=>document.querySelectorAll('[data-vh-promotions]:not([data-promo-ready])').forEach(root=>{root.dataset.promoReady='true';const slides=[...root.querySelectorAll('[data-vh-promo-slide]')],controls=root.querySelector('[data-vh-promo-controls]'),pause=root.querySelector('[data-vh-promo-pause]'),count=root.querySelector('[data-vh-promo-count]'),motion=matchMedia('(prefers-reduced-motion: reduce)');let index=0,paused=motion.matches,visible=false,hovered=false,timer;controls.hidden=slides.length<2;const sync=()=>{pause.textContent=paused?pause.dataset.play:pause.dataset.pause;pause.setAttribute('aria-pressed',String(paused));clearInterval(timer);if(!paused&&!hovered&&visible&&!document.hidden&&root.isConnected)timer=setInterval(()=>show(index+1,false),8000);};const show=(next,manual)=>{index=(next+slides.length)%slides.length;slides.forEach((slide,i)=>slide.hidden=i!==index);count.textContent=(index+1)+' / '+slides.length;count.setAttribute('aria-live',manual?'polite':'off');if(manual)paused=true;sync();};root.querySelector('[data-vh-promo-prev]').addEventListener('click',()=>show(index-1,true));root.querySelector('[data-vh-promo-next]').addEventListener('click',()=>show(index+1,true));pause.addEventListener('click',()=>{paused=!paused;sync();});root.addEventListener('focusin',event=>{if(!event.target.closest('[data-vh-promo-pause]')){paused=true;sync();}});root.addEventListener('pointerenter',event=>{if(event.pointerType==='mouse'){hovered=true;sync();}});root.addEventListener('pointerleave',()=>{hovered=false;sync();});let touchX=null;root.addEventListener('touchstart',event=>{touchX=event.touches[0].clientX;},{passive:true});root.addEventListener('touchend',event=>{if(touchX===null)return;const delta=event.changedTouches[0].clientX-touchX;if(Math.abs(delta)>60)show(index+(delta<0?1:-1),true);touchX=null;},{passive:true});document.addEventListener('visibilitychange',sync);motion.addEventListener('change',()=>{paused=motion.matches;sync();});new IntersectionObserver(entries=>{visible=entries[0].isIntersecting;sync();},{threshold:.15}).observe(root);show(0,false);});setup();document.addEventListener('shopify:section:load',setup);})();


  } catch(e) { console.error(e); }
})();
})();
